export default __webpack_public_path__ + "src/assets/coinbase.5763585023e878564693cad8d3459fa0.svg";